<template>
    <div :class="`app-step-wrapper step-${ this.appStep }`">
        <Transition @before-enter="delayedAppear" name="component-fade" mode="out-in">
            <component :is="currentComponent" @app-step="urlStepChange" />
        </Transition>
        <NavbarWebdemo @app-step-from-navbar="urlStepChange" :appStepForNavbar="appStep" />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
    data() {
        return {
            appStep: 0,
            param: 'step',
            currentComponent: null
        }
    },
    watch: {
        appStep(newStep) {
            this.loadComponent(newStep)
        }
    },
    created() {
        this.loadComponent(this.appStep)
    },
    methods: {
        loadComponent(step) {
            this.currentComponent = defineAsyncComponent(() => import(`./Steps/AppStep${step}.vue`))
        },
        urlStepChange(stepFromEmit) {
            this.appStep = stepFromEmit

            let url = new URL(window.location.href)
            url.searchParams.set(this.param, stepFromEmit)

            window.history.replaceState({}, '', url);
        },

        delayedAppear() {
            setTimeout(() => {
                document.getElementsByClassName('app-step-wrapper')[0].style.opacity = 1
            }, "500");
        }
    }
}
</script>

<style scoped>
    .app-step-wrapper {
        opacity: 0;
        transition: opacity 1s ease;
    }

    .component-fade-enter-active {
        transition: opacity 1s ease;
    }
    .component-fade-leave-active {
        transition: opacity 1s ease;
    }

    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }
    
</style>